import React from 'react';
import { TagFilled, CloseOutlined } from '@ant-design/icons';
import { cn } from '../../utils/ClassNamesUtils';

const CHIP_BASE_CLASS =
	'bodyregular box-border inline-flex h-[30px] items-center gap-1 rounded-full border border-solid px-2 py-[3px]';

const CHIP_CLASS = '!border-grey-5 bg-white text-character-primary';

const CHIP_ON_DARK_CLASS = '!border-white bg-transparent text-white';

export interface ChipLabel {
	id: number;
	label: string;
	color?: string;
}

interface Props {
	label: ChipLabel | null | undefined;
	onClick?: (event: React.MouseEvent) => void;
	onRemove?: (event: React.MouseEvent) => void;
	onDark?: boolean;
	className?: string;
}

export const LabelChip: React.FC<Props> = ({
	label,
	onClick,
	onRemove,
	onDark = false,
	className,
}) => {
	if (!label) return null;
	return (
		<span
			onClick={onClick}
			className={cn(
				CHIP_BASE_CLASS,
				onDark ? CHIP_ON_DARK_CLASS : CHIP_CLASS,
				onClick ? 'cursor-pointer' : 'cursor-default',
				className
			)}
		>
			<TagFilled className="text-xs" style={{ color: label.color }} />
			<span
				className={cn(
					'max-w-[140px] overflow-hidden text-ellipsis whitespace-nowrap',
					onDark ? 'text-white' : 'text-black/65'
				)}
			>
				{label.label}
			</span>
			{onRemove ? (
				<CloseOutlined
					onClick={(event) => {
						event.stopPropagation();
						onRemove(event);
					}}
					className={cn('ml-0.5 cursor-pointer text-[10px]', onDark ? 'text-white' : 'text-grey-7')}
				/>
			) : null}
		</span>
	);
};

export default LabelChip;
